<div class="survey-step-id">Step ID: {{ stepData?._id }}</div>
<div class="survey-step-type">Step Type: {{ stepData?.stepType }}</div>
<button (click)="emitTest()">Test Emit</button>
